export const defaultMeta = {
  title: 'Alpaca City - A miracle city where DeFi meets Alpaca NFTs',
  meta: [
    // Open Graph / Facebook
    {
      property: 'og:title',
      content: 'Alpaca City - A miracle city where DeFi meets Alpaca NFTs',
    },
    { property: 'og:site_name', content: 'Alpaca City' },
    { property: 'og:type', content: 'website' },
    {
      property: 'og:url',
      content: 'https://alpaca.city/',
    },
    {
      property: 'og:image',
      content: 'https://guide.alpaca.city/i/home-screen.png',
    },
    {
      property: 'og:description',
      content: 'Alpaca City is endeavoring to create a more accessible DeFi ecosystem by combining the power of yield farming and NFT.',
    },
    // Twitter
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
    {
      property: 'twitter:url',
      content: 'https://alpaca.city/',
    },
    {
      property: 'twitter:title',
      content: 'Alpaca City - A miracle city where DeFi meets Alpaca NFTs',
    },
    {
      property: 'twitter:description',
      content: 'Alpaca City is endeavoring to create a more accessible DeFi ecosystem by combining the power of yield farming and NFT.',
    },
    {
      property: 'twitter:site',
      content: '@CityAlpaca',
    },
    {
      property: 'twitter:image',
      content: 'https://guide.alpaca.city/i/home-screen.png',
    },
    {
      vmid: 'description',
      name: 'description',
      content: 'Alpaca City is endeavoring to create a more accessible DeFi ecosystem by combining the power of yield farming and NFT.',
    },
  ],
  link: [
    {
      rel: 'icon',
      href: 'https://alpaca.city/favicon.ico',
      type: 'image/x-icon',
    },
  ],
};
